import React from 'react';
import { Link } from 'react-router-dom';
import { RatingStrawberries } from './RatingStrawberries';
import './ShowCard.css';

const getLocalizedType = (type) => {
  if (!type) return '';
  const lowercaseType = type.toLowerCase();
  if (lowercaseType === 'movie' || lowercaseType === 'film') {
    return 'Film';
  }
  if (lowercaseType === 'series' || lowercaseType === 'tv_series') {
    return 'Serie';
  }
  return type;
};

export function ShowCard({ 
  show, 
  index, 
  showStatus,
  activeTab,
  onStatusClick,
  onRatingClick,
  onShareClick,
  onStreamingSourceClick,
  onRatingOverviewClick,
  hideRating = false,
  hideIndex = false,
  hideActions = false,
  isLoading,
  showRatingButton = true,
  onClick
}) {
  const navigateId = show.firestore_id || show.id;
  
  const renderStatusButton = () => {
    const statusConfig = {
      'watching': {
        icon: 'fa-satellite-dish',
        label: 'Tittar på',
        title: 'Tittar på'
      },
      'watchlist': {
        icon: 'fa-check',
        label: 'Ska se',
        title: 'Ska se'
      },
      'seen': {
        icon: 'fa-check-double',
        label: 'Har sett',
        title: 'Har sett'
      },
      'archived': {
        icon: 'fa-trash',
        label: 'Arkiverad',
        title: 'Arkiverad'
      },
      'none': {
        icon: 'fa-plus',
        label: 'Status',
        title: 'Lägg till'
      }
    };

    const config = statusConfig[showStatus] || statusConfig.none;

    return (
      <button 
        className={`action-button status-button ${showStatus !== 'none' ? 'active' : ''}`}
        onClick={onStatusClick}
        disabled={isLoading}
        title={config.title}
      >
        <i className={`fas ${config.icon}`}></i>
        <span className="action-label">{config.label}</span>
      </button>
    );
  };
  
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick(show);
    }
  };

  return (
    <div className="show-row">
      <Link 
        to={`/show/${navigateId}`} 
        className="show-card"
        onClick={handleClick}
      >
        <div className="show-poster-container">
          {!hideIndex && <div className="index-badge">{index + 1}</div>}
          <img
            src={show.poster}
            alt={show.title}
            className="show-poster"
          />
        </div>
        
        <div className="show-info">
          <h3 className="show-title">{show.title}</h3>
          
          <div className="popular-show-metadata">
            <span className="show-year">
              {show.year}
              {show.type && ` · ${getLocalizedType(show.type)}`}
              {show.total_seasons && 
                ` · ${show.total_seasons} ${show.total_seasons === 1 ? 'säsong' : 'säsonger'}`
              }
            </span>
          </div>

          {!hideRating && (
            <div className="rating-section">
              <div 
                className="rating-overview" 
                onClick={onRatingOverviewClick}
                style={{ cursor: 'pointer' }}
              >
                {activeTab === 'rated' && show.rating ? (
                  <div className="friends-rating-stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <img 
                        key={star}
                        src={star <= show.rating 
                          ? "/images/strawberry-filled.png" 
                          : "/images/strawberry-empty.png"} 
                        alt={`Rating ${star}`}
                        className="strawberry-icon"
                        style={{ width: '20px', height: '20px', margin: '0' }}
                      />
                    ))}
                  </div>
                ) : show.averageRating ? (
                  <RatingStrawberries 
                    rating={show.averageRating}
                    ratingCount={show.ratingCount}
                    readonly={true}
                    showRatingCount={true}
                    showDecimals={true}
                  />
                ) : (
                  <span className="show-card-no-ratings">
                    {show.noRatingText || "Inga röster än"}
                  </span>
                )}
              </div>
            </div>
          )}

          <div className="streaming-services">
            {show.streamingSources?.map((source, i) => (
              <span 
                key={i} 
                className="streaming-service"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onStreamingSourceClick(e);
                }}
                style={{ cursor: 'pointer' }}
              >
                {source}
              </span>
            ))}
            {!show.streamingSources?.length && (
              <button 
                className="add-streaming-button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onStreamingSourceClick(e);
                }}
              >
                <i className="fas fa-plus"></i>
                <span>Lägg till plattform</span>
              </button>
            )}
          </div>
        </div>
      </Link>

      {!hideActions && (
        <div className="show-actions">
          {renderStatusButton()}

          {showRatingButton && (
            <button 
              className="action-button rating-button"
              onClick={onRatingClick}
              title="Rösta"
            >
              <i className="fas fa-thumbs-up"></i>
              <span className="action-label">Rösta</span>
            </button>
          )}

          <button 
            className="action-button share-button"
            onClick={onShareClick}
            title="Dela"
          >
            <i className="fas fa-share-alt"></i>
            <span className="action-label">Dela</span>
          </button>
        </div>
      )}
    </div>
  );
} 